import { render, staticRenderFns } from "./spike.vue?vue&type=template&id=53ebbd70&scoped=true&"
import script from "./spike.vue?vue&type=script&lang=js&"
export * from "./spike.vue?vue&type=script&lang=js&"
import style0 from "./spike.vue?vue&type=style&index=0&id=53ebbd70&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ebbd70",
  null
  
)

export default component.exports